import React, { useEffect, useState } from 'react';

export const Z_INDEX_MENU_PORTAL_TARGET = 750;

export const MenuPortalContext = React.createContext<HTMLDivElement | null>(null);

/**
 * A DOM element that can be used as the menuPortalTarget for react-select components and has the right z-index
 * to make sure that they are visible within dialogs.
 */
export const MenuPortal: React.FunctionComponent<React.PropsWithChildren> = ({
  children,
}) => {
  const [ref, setRef] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = document.createElement('div');
    el.style.zIndex = String(Z_INDEX_MENU_PORTAL_TARGET);
    el.className = 'menu-portal-target';
    document.body.appendChild(el);
    setRef(el);
  }, []);

  return <MenuPortalContext.Provider value={ref}>{children}</MenuPortalContext.Provider>;
};
